import { IONICONS } from "@/components/icons/ionicons";

export function IonIcon({ name, size = 22, className = "", testid }) {
  return (
    <svg
      viewBox="0 0 512 512"
      width={size}
      height={size}
      aria-hidden="true"
      data-testid={testid}
      className={`shrink-0 ${className}`}
      dangerouslySetInnerHTML={{ __html: IONICONS[name] }}
    />
  );
}

// App PNG line icon; tinted like the app's tintColor unless the artwork keeps its own colours
export function PngIcon({ src, width, height, tint = true, testid, className = "" }) {
  if (!tint) {
    return (
      <img src={src} alt="" width={width} height={height} data-testid={testid} className={`shrink-0 ${className}`} draggable="false" />
    );
  }
  return (
    <span
      aria-hidden="true"
      data-testid={testid}
      className={`inline-block shrink-0 bg-current ${className}`}
      style={{
        width,
        height,
        WebkitMaskImage: `url(${src})`,
        maskImage: `url(${src})`,
        WebkitMaskSize: "contain",
        maskSize: "contain",
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskPosition: "center",
      }}
    />
  );
}

export const APP_ICONS = {
  trofee: { src: "/app/icons/trofee.png", width: 23, height: 25 },
  jachtuitrusting: { src: "/app/icons/jachtuitrusting.png", width: 57, height: 22 },
  nazoek: { src: "/app/icons/aanschot-nazoek.png", width: 67, height: 20, tint: false },
};
